export enum RequestStatus {
	FAILURE = 'FAILURE',
	SUCCESS = 'SUCCESS',
}
export enum OrderStatus {
	BOOKED = 'BOOKED',
	AWAITINGSTOCK = 'AWAITING_STOCK',
	AWAITQUINTIQBOOK = 'AWAIT_QUINTIQ_BOOK',
	UNBOOKED = 'UNBOOKED',
	ROUTEPLANNING = 'ROUTE_PLANNING',
	STOCKRECEIVED = 'STOCK_RECEIVED',
	B4P = 'B4P',
	PICKING = 'PICKING',
	PREADVICECREATED = 'PREADVICE_CREATED',
	LOADED = 'LOADED',
	INPROGRESS = 'IN_PROGRESS',
	COLLECTED = 'COLLECTED',
	DELIVERED = 'DELIVERED',
	AUDITCLOSED = 'AUDIT_CLOSED',
	CANCELLED = 'CANCELLED',
}

export enum StockStatus {
	AWAITINGSTOCK = 'AWAITING_STOCK',
	STOCKRECEIVED = 'STOCK_RECEIVED',
}
